import script from "./grouped-table-items.vue?vue&type=script&setup=true&lang=js"
export * from "./grouped-table-items.vue?vue&type=script&setup=true&lang=js"

import "./grouped-table-items.vue?vue&type=style&index=0&id=0e841689&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e841689"]])

export default __exports__